import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Eye, EyeOff } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { useAdminAuth } from '../context/AdminAuthContext';
import { toast } from 'sonner';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_beauty-bazaar-117/artifacts/2j1k3po7_Reggae%20Essences%20Logo.png";

export const AdminLoginPage = () => {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { isAuthenticated, login } = useAdminAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/admin');
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    setTimeout(() => {
      const success = login(password);
      if (success) {
        toast.success('Welcome back!');
        navigate('/admin');
      } else {
        toast.error('Invalid password');
      }
      setLoading(false);
    }, 500);
  };

  return (
    <div className="min-h-screen bg-forest flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <img
            src={LOGO_URL}
            alt="Reggae Essences"
            className="h-24 w-auto mx-auto mb-4"
          />
          <h1 className="font-heading text-2xl font-bold text-cream">Admin Portal</h1>
          <p className="text-cream/60 mt-2">Enter your password to continue</p>
        </div>

        {/* Login Form */}
        <form onSubmit={handleSubmit} className="bg-cream rounded-2xl p-8 shadow-2xl">
          <div className="mb-6">
            <label className="block text-sm font-medium text-forest mb-2">
              Admin Password
            </label>
            <div className="relative">
              <Lock className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-warm-brown" />
              <Input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter admin password"
                className="pl-12 pr-12 py-6 rounded-xl border-warm-brown/20 focus:border-forest"
                data-testid="admin-password-input"
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-4 top-1/2 -translate-y-1/2 text-warm-brown hover:text-forest"
              >
                {showPassword ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}
              </button>
            </div>
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="w-full bg-forest hover:bg-forest-light text-cream py-6 rounded-xl"
            data-testid="admin-login-btn"
          >
            {loading ? 'Logging in...' : 'Login to Admin'}
          </Button>
        </form>

        {/* Back to store */}
        <div className="text-center mt-6">
          <a href="/" className="text-cream/60 hover:text-gold transition-colors text-sm">
            ← Back to Store
          </a>
        </div>
      </div>
    </div>
  );
};
